import { render } from "./PerformanceAttribution.vue?vue&type=template&id=6b84885d&scoped=true"
import script from "./PerformanceAttribution.vue?vue&type=script&lang=js"
export * from "./PerformanceAttribution.vue?vue&type=script&lang=js"

import "./PerformanceAttribution.vue?vue&type=style&index=0&id=6b84885d&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b84885d"]])

export default __exports__